import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { ColumnsByTableIdFragmentGql } from './TableColumnsByIdQueryGql';

export const VirtualConnectionTableColumnsByIdQueryGql: DocumentNode = gql`
query VirtualConnectionTableColumnsByIdQuery(
  $vizportalUrlId: String!,
  $first: Int!,
  $offset: Int!,
  $orderBy: ColumnSortOrder!,
) {
  virtualConnectionTables(filter: { vizportalUrlId: $vizportalUrlId }) {
    id
    name
    vizportalUrlId
    columnsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...ColumnsByTableIdFragment
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: { field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC }
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection { totalCount }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: { field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC }
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection { totalCount }
      }
    }
  }
}
${ColumnsByTableIdFragmentGql}
`;
